import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';
import { frontendURL } from 'dashboard/helper/URLHelper';
import VoiceCenterIndex from './VoiceCenterIndex.vue';
import VoiceQueuesIndex from './VoiceQueuesIndex.vue';

const voiceFeatureMeta = {
  featureFlag: FEATURE_FLAGS.CHANNEL_VOICE,
  module: FEATURE_FLAGS.CHANNEL_VOICE,
  installationTypes: [INSTALLATION_TYPES.CLOUD, INSTALLATION_TYPES.ENTERPRISE],
};

const voiceOperationsMeta = {
  ...voiceFeatureMeta,
  permissions: ['administrator', 'inbox_manage', 'voice_call_transfer'],
};

const voiceSettingsMeta = {
  ...voiceFeatureMeta,
  permissions: ['administrator', 'inbox_manage'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/voice-queues'),
    name: 'voice_queues_index',
    component: VoiceCenterIndex,
    meta: voiceOperationsMeta,
  },
  {
    path: frontendURL('accounts/:accountId/voice-queues/settings'),
    name: 'voice_queues_settings',
    component: VoiceQueuesIndex,
    meta: voiceSettingsMeta,
  },
];
